import "./features.css";
import Reveal from "../reveal/Reveal.jsx";
import {
  CollabIllustration,
  ChatIllustration,
  QuizIllustration,
  ExamIllustration,
} from "../../illustrations/Illustrations.jsx";

const FEATURES = [
  {
    Illustration: CollabIllustration,
    title: "Collaborative Learning",
    text: "Study and review on your own and/or with other students using an assessment system and a tutor at your fingertips, no matter where you are.",
  },
  {
    Illustration: ChatIllustration,
    title: "Real-time Chat",
    text: "A secure discussion space for each class where students can ask questions and help one another.",
  },
  {
    Illustration: QuizIllustration,
    title: "Quiz &amp; challenges",
    text: "Fun quizzes and interclass challenges to reinforce learning and keep students motivated.",
  },
  {
    Illustration: ExamIllustration,
    title: "Assessments &amp; Progress Tracking",
    text: "Assessments at each level, automatic grading, and detailed tracking of each student's progress.",
  },
];

export default function Features() {
  return (
    <section id="fonctionnalites" className="features-section">
      <div className="features-container">
        <Reveal as="div" className="section__head">
          <span className="eyebrow">Features, All-in-one</span>
          <h2>Everything you need to learn, no matter where you live</h2>
          <p>
            A platform designed to bridge the digital divide and provide the
            same quality of education in rural, urban, and suburban areas.
          </p>
        </Reveal>

        <div className="features-grid">
          {FEATURES.map((f, i) => (
            <Reveal
              as="article"
              className="feature-card"
              delay={i * 90}
              key={f.title}
            >
              <div className="feature-card__icon">
                <f.Illustration className="feature-card__svg" />
              </div>
              <h3 dangerouslySetInnerHTML={{ __html: f.title }} />
              <p dangerouslySetInnerHTML={{ __html: f.text }} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
